/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupBySentimentKind = (typeof GroupBySentimentKind)[keyof typeof GroupBySentimentKind];

export const GroupBySentimentKind = {
  sentiment: 'sentiment',
} as const;
